import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-32 border-t border-[#0F172A]/10 bg-[#F7F5F0]">
      <div className="container-x py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-display text-3xl text-[#0F172A]">EB·Immigration</div>
          <p className="mt-4 text-[#4A4D50] max-w-md leading-relaxed">
            A boutique U.S. immigration practice focused exclusively on the most demanding
            employment-based petitions — EB-1A, EB-2 NIW, and O-1.
          </p>
          <div className="mt-6 eyebrow text-[#4A4D59]">Attorney Advertising · Prior results do not guarantee outcomes</div>
        </div>
        <div className="md:col-span-3">
          <div className="eyebrow mb-4">Practice</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/practice-areas" className="link-underline">EB-1A · Extraordinary Ability</Link></li>
            <li><Link to="/practice-areas" className="link-underline">EB-2 NIW · National Interest</Link></li>
            <li><Link to="/practice-areas" className="link-underline">O-1 · Extraordinary Ability Visa</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="eyebrow mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-[#4A4D50]">
            <li>hello@ebimmigration.law</li>
            <li>+1 (415) 555-0132</li>
            <li>By appointment · Global · Remote</li>
          </ul>
          <div className="mt-8">
            <Link to="/case-review" data-testid="footer-cta" className="btn-primary text-sm !py-3 !px-6">Request Case Review</Link>
          </div>
        </div>
      </div>
      <div className="hairline" />
      <div className="container-x py-8 flex flex-col sm:flex-row justify-between gap-4 text-xs text-[#4A4D50] font-mono-plex">
        <span>© {new Date().getFullYear()} EBImmigration PLLC</span>
        <span>Not intended as legal advice · Contact does not create attorney-client relationship</span>
      </div>
    </footer>
  );
}
